import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListJenisBerkas } from "@/services/getData"

export default function MasterJenisBerkasPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listJenisBerkas"],
    queryFn: getListJenisBerkas,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
